import sortBy from 'lodash/sortBy'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import type {ProficiencyReportAttrs} from '@freckle/school/ts/proficiency-report/models/proficiency-report'
import type {
  ProficiencyReportStudentGroupsT,
  ProficiencyReportTeacherGroupDataT,
} from '@freckle/school/ts/proficiency-report/models/proficiency-report'

export type ProficiencyReportTableRowT = {
  averageGradeLevel: number | undefined | null
  schoolId: number
  schoolName: string
  studentGroups: ProficiencyReportStudentGroupsT
  teacherGroups: Array<ProficiencyReportTeacherGroupDataT>
}

export type StudentCategoriesT = 'insufficient' | 'below' | 'within' | 'above'
export const StudentCategories = {
  Insufficient: 'insufficient' as StudentCategoriesT,
  Below: 'below' as StudentCategoriesT,
  Within: 'within' as StudentCategoriesT,
  Above: 'above' as StudentCategoriesT,
  all: function (): Array<StudentCategoriesT> {
    return [
      StudentCategories.Insufficient,
      StudentCategories.Below,
      StudentCategories.Within,
      StudentCategories.Above,
    ]
  },
  forDisplay: function (category: StudentCategoriesT): string {
    switch (category) {
      case StudentCategories.Insufficient:
        return 'Insufficient Data'
      case StudentCategories.Below:
        return 'Below'
      case StudentCategories.Within:
        return 'Within'
      case StudentCategories.Above:
        return 'Above'
      default:
        throw new Error(`${category} is not a valid Student Category`)
    }
  },
}

export const getProficiencyReportTableDataFromCollection = (
  proficiencyReports: Array<ProficiencyReportAttrs>,
  schools: Array<SchoolAttrs>,
): Array<ProficiencyReportTableRowT> =>
  sortBy(
    proficiencyReports.flatMap(proficiencyReport => {
      const school = schools.find(school => school.id === proficiencyReport.schoolId)

      return school === undefined
        ? []
        : [
            {
              schoolId: school.id,
              schoolName: school.name,
              averageGradeLevel: proficiencyReport.averageGradeLevel,
              studentGroups: {
                insufficientData: proficiencyReport.studentGroups.insufficientData,
                belowGradeLevel: proficiencyReport.studentGroups.belowGradeLevel,
                aboveGradeLevel: proficiencyReport.studentGroups.aboveGradeLevel,
                withinGradeLevel: proficiencyReport.studentGroups.withinGradeLevel,
              },
              teacherGroups: proficiencyReport.teacherGroups,
            },
          ]
    }),
    'schoolName',
  )
